(function () {
  const wrappers = [
    { input: 'PredictiveSearchInput-desktop', results: 'PredictiveSearchResults-desktop' },
    { input: 'PredictiveSearchInput-mobile', results: 'PredictiveSearchResults-mobile' }
  ];

  wrappers.forEach(function (ids) {
    const input = document.getElementById(ids.input);
    const resultsEl = document.getElementById(ids.results);
    if (!input || !resultsEl) return;

    let debounceTimer = null;
    let activeController = null;
    let activeIndex = -1;
    let lastQuery = '';

    function closeResults() {
      resultsEl.classList.remove('is-open');
      resultsEl.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function openResults() {
      resultsEl.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function escapeHtml(str) {
      return (str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderLoading() {
      resultsEl.innerHTML = '<div class="predictive-search-status">Searching…</div>';
      openResults();
    }

    function renderNoResults(query) {
      resultsEl.innerHTML =
        '<div class="predictive-search-status">No results for "' + escapeHtml(query) + '"</div>';
      openResults();
    }

    function formatMoney(price) {
      const format = window.shopMoneyFormat || '${{amount}}';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = format.match(placeholderRegex);
      if (!match) return format;

      const numericPrice = Number(price) || 0;
      let formattedAmount;

      switch (match[1]) {
        case 'amount_no_decimals':
          formattedAmount = Math.round(numericPrice).toString();
          break;
        case 'amount_with_comma_separator':
          formattedAmount = numericPrice.toFixed(2).replace('.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formattedAmount = Math.round(numericPrice).toLocaleString('de-DE');
          break;
        case 'amount':
        default:
          formattedAmount = numericPrice.toFixed(2);
          break;
      }

      return format.replace(placeholderRegex, formattedAmount);
    }

    function renderResults(query, products) {
      if (!products.length) {
        renderNoResults(query);
        return;
      }

      let html = '<div class="predictive-search-group-label">Products</div><ul class="predictive-search-list">';

      products.forEach(function (product) {
        const image = product.featured_image ? product.featured_image.url : product.image;
        const price = product.price ? '<span>' + formatMoney(product.price) + '</span>' : '';
        const compareAt =
          product.compare_at_price_max &&
          product.compare_at_price_max > product.price_max
            ? '<span class="compare-at">' + formatMoney(product.compare_at_price) + '</span>'
            : '';

        html +=
          '<li class="predictive-search-item" role="option">' +
            '<a href="' + product.url + '">' +
              (image
                ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
                : '') +
              '<span class="predictive-search-item-info">' +
                '<span class="predictive-search-item-title">' + escapeHtml(product.title) + '</span>' +
                '<span class="predictive-search-item-price">' + price + compareAt + '</span>' +
              '</span>' +
            '</a>' +
          '</li>';
      });

      html += '</ul>';
      html +=
        '<a class="predictive-search-view-all" href="' +
        input.form.action + '?q=' + encodeURIComponent(query) +
        '">View all results for "' + escapeHtml(query) + '"</a>';

      resultsEl.innerHTML = html;
      openResults();
    }

    function fetchResults(query) {
      if (activeController) activeController.abort();
      activeController = new AbortController();

      const url =
        window.routesPredictiveSearchUrl +
        '.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&resources[options][fields]=title,vendor,product_type';

      fetch(url, { signal: activeController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search request failed');
          return response.json();
        })
        .then(function (data) {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(query, products);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          closeResults();
        });
    }

    function renderCategoryPrompt(query, label, url) {
      resultsEl.innerHTML =
        '<a class="predictive-search-view-all" href="' + url + '?q=' + encodeURIComponent(query) + '">' +
        'Search "' + escapeHtml(query) + '" in ' + escapeHtml(label) +
        '</a>';
      openResults();
    }

    function runSearch(query) {
      const categoryState = window.searchCategoryState;
      if (categoryState && categoryState.url) {
        renderCategoryPrompt(query, categoryState.label, categoryState.url);
        return;
      }
      renderLoading();
      fetchResults(query);
    }

    // Re-fire on the input this file was loaded for, in case the user typed
    // between the focus event (which triggered this load) and now.
    if (input.value.trim().length >= 2) {
      runSearch(input.value.trim());
    }

    input.addEventListener('input', function () {
      const query = input.value.trim();
      lastQuery = query;
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        runSearch(query);
      }, 250);
    });

    input.addEventListener('focus', function () {
      if (lastQuery.length >= 2 && resultsEl.innerHTML) openResults();
    });

    input.addEventListener('keydown', function (event) {
      const items = resultsEl.querySelectorAll('.predictive-search-item');
      if (!items.length) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
      } else if (event.key === 'Enter' && activeIndex > -1) {
        event.preventDefault();
        const link = items[activeIndex].querySelector('a');
        if (link) window.location.href = link.href;
        return;
      } else if (event.key === 'Escape') {
        closeResults();
        return;
      } else {
        return;
      }

      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === activeIndex);
      });
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('click', function (event) {
      if (!resultsEl.contains(event.target) && event.target !== input) {
        closeResults();
      }
    });
  });
})();